"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgIcon_1 = __importDefault(require("./SvgIcon"));
var AngleDownIcon = function (props) {
    return (react_1.default.createElement(SvgIcon_1.default, __assign({}, props),
        react_1.default.createElement("path", { xmlns: "http://www.w3.org/2000/svg", fill: "#FFF", fillRule: "evenodd", d: "M7.61105234,1.24305289 C7.23357641,0.910562568 6.64505651,0.920380305 6.28024642,1.2652535 C5.91543633,1.6101267 5.90554835,2.16601382 6.25788698,2.52226769 L16.4724222,12.1691752 L6.25846924,21.4795051 C5.90709824,21.8356948 5.91741079,22.3907202 6.28179756,22.7350452 C6.64618434,23.0793701 7.23379611,23.0893496 7.61105234,22.75762 L19,12.1691752 L7.61105234,1.24305289 Z", transform: "rotate(90 12.5 12)" })));
};
exports.default = AngleDownIcon;
